// Widget çerçevesi — başlık, düzenleme modunda sürükleme tutamağı ve kaldır düğmesi, hata sınırı.
import type { ReactNode } from 'react';
import { GripVertical, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary';
import { IconButton } from '@/shared/ui/IconButton';

export interface WidgetFrameProps {
  title: string;
  editing: boolean;
  onRemove: () => void;
  children: ReactNode;
  className?: string;
}

export function WidgetFrame({ title, editing, onRemove, children, className }: WidgetFrameProps) {
  const { t } = useTranslation();
  return (
    <section className={cn('border-border bg-bg-elevated flex h-full min-h-0 flex-col overflow-hidden rounded-xl border', editing && 'border-brand-500/50', className)} aria-label={title}>
      <header className={cn('flex shrink-0 items-center gap-1 px-3 py-1.5', editing && 'widget-drag-handle cursor-move')}>
        {editing ? <GripVertical className="text-fg-subtle h-3.5 w-3.5 shrink-0" aria-hidden="true" /> : null}
        <h2 className="text-fg-muted min-w-0 flex-1 truncate text-xs font-semibold tracking-wide uppercase">{title}</h2>
        {editing ? (
          <IconButton label={t('home.removeWidget')} size="sm" onClick={onRemove} onPointerDown={(e) => e.stopPropagation()}>
            <X className="h-3.5 w-3.5" />
          </IconButton>
        ) : null}
      </header>
      <div className="min-h-0 flex-1 overflow-hidden px-3 pb-3">
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
    </section>
  );
}
